import { useQuery } from '@tanstack/react-query';
import { LambdaStatusResponse } from '../store/types';
import { SportsResponse, SlateResponse } from '../../common/store/types';

export const useGetSupportedSports = () => {

  return useQuery<SportsResponse[], Error>({
    queryKey: ['contests'],
    queryFn: () => {
      const data: Promise<SportsResponse[]> = fetch(`${process.env.REACT_APP_API_URL}/api/contests/getSupportedSports?`).then(res => res.json());

      return data;
    },
    refetchOnWindowFocus: false,
  })
};

export const useVerifyCanRun = (siteContestId: string, disable: boolean) => {
  const params = {
    siteContestId,
  }
  return useQuery<boolean, Error>({
    queryKey: [`verification-${siteContestId}`],
    queryFn: () => {
      const data: Promise<boolean> = fetch(`${process.env.REACT_APP_API_URL}/api/contests/getPreContestSimValidation?` + new URLSearchParams(params)).then(res => res.text()).then(text => text === 'true');

      return data;
    },
    refetchOnWindowFocus: false,
    enabled: !disable
  })
};

export const useGetSlateInfo = (sport: string, site:string,  disable: boolean) => {
  const params = {
    sport,
    site
  }
  return useQuery<SlateResponse[], Error>({
    queryKey: [`slateInfo-${sport}-${site}`],
    queryFn: () => {
      const data: Promise<SlateResponse[]> = fetch(`${process.env.REACT_APP_API_URL}/api/contests/getPreContestSlateInfo?` + new URLSearchParams(params)).then(res => res.json());

      return data;
    },
    refetchOnWindowFocus: false,
    enabled: !disable
  })
};

export const useGetProjectionsTemplate = (slateId: string, disable: boolean) => {
  const params = {
    slateId,
  }
  return useQuery<string[], Error>({
    queryKey: [`projections-template-${slateId}`],
    queryFn: () => {
      const data: Promise<string[]> = fetch(`${process.env.REACT_APP_API_URL}/api/contests/getProjectionsTemplate?` + new URLSearchParams(params)).then(res => res.json());

      return data;
    },
    refetchOnWindowFocus: false,
    enabled: !disable,
  })
};

// How long after a sim starts we keep polling its status
export const STATUS_POLL_TIMEOUT_MS = 300000;

export const useGetLambdaStatusForContest = (slateId: string, user: string, disable: boolean = false, simulationStartTime: number | null = null) => {
  const params = {
    slateId,
    user
  };

  return useQuery<LambdaStatusResponse, Error>({
    queryKey: [`lambaStatus-${slateId}-${user}`],
    queryFn: () => {
      const data: Promise<LambdaStatusResponse> = fetch(`${process.env.REACT_APP_API_URL}/api/contests/getSimulationStatus?` + new URLSearchParams(params)).then(res => res.json());

      return data;
    },
    refetchInterval: (data) => {
      // Stop polling if progress is complete (1) or error/previous result (-1)
      if (data?.progress === 1 || data?.progress === -1) {
        return false;
      }

      // Stop polling after 5 minutes if we have a start time
      if (simulationStartTime) {
        if (Date.now() - simulationStartTime > STATUS_POLL_TIMEOUT_MS) {
          console.warn('Simulation polling timed out after 5 minutes');
          return false;
        }
      }

      return 5000; // Continue polling every 5 seconds
    },
    enabled: !disable
  })
}